import { render, staticRenderFns } from "./Flags.vue?vue&type=template&id=7c6b3649"
import script from "./Flags.vue?vue&type=script&lang=js"
export * from "./Flags.vue?vue&type=script&lang=js"
import style0 from "./Flags.vue?vue&type=style&index=0&id=7c6b3649&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports